import { useQuery } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { DefaultErrorMessage } from '../displayStrings';
import { groupsApi } from '../api/groups.api';

export const useGroups = () => {
  const { showToast } = useToastProvider();
  const { companyId } = useCurrentUser();

  return useQuery(['groupsList', companyId], () => groupsApi.fetchGroups(), {
    onError: () => {
      showToast({
        title: 'Could not retrieve groups',
        description: DefaultErrorMessage,
        status: 'error',
      });
    },
  });
};
